import React, { ImgHTMLAttributes, useState } from 'react';
interface SafeImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc: string;
}
export function SafeImage({
  src,
  fallbackSrc,
  alt,
  onError,
  ...props
}: SafeImageProps) {
  const [activeSrc, setActiveSrc] = useState(src);
  const [hasFallenBack, setHasFallenBack] = useState(false);
  return <img {...props} src={activeSrc} alt={alt} onError={event => {
    onError?.(event);
    if (!hasFallenBack) {
      setHasFallenBack(true);
      setActiveSrc(fallbackSrc);
    }
  }} data-id="element-234" data-mp="2wighj07dcus7" />;
}